import { db } from '../../src/main'

export function searchAddress (addresses, query) {
  if (!query) {
    return addresses
  }
  let aliasMatch = []
  let otherMatch = []
  for (var i = 0; i < addresses.length; i++) {
    let address = addresses[i]
    if (address.alias.toLowerCase().indexOf(query.toLowerCase()) !== -1) {  // alias name match
      aliasMatch.push(address)
    } else {
      for (var prop in address) {
        if (prop === 'alias') continue  // skip alias property
        let value = address[prop]
        if (value.toLowerCase().indexOf(query.toLowerCase()) !== -1) {  // other filed partially matched
          otherMatch.push(address)
          break
        }
      }
    }   
  }
  let result = aliasMatch.concat(otherMatch)
  return result
}

export function saveAddress (address) {
  if (address.docId === '') {
    let docRef = db.collection('addressBook').doc()
    let newID = docRef.id
    address.docId = newID
  }
  return new Promise((resolve, reject) => {
    db.collection('addressBook').doc(address.docId).set(address, {merge: true}).then(() => {
      resolve('Address updated')
    }).catch(err => {
      // console.log(err)
      reject(err)
    })
  })
}

export function deleteAddress (address) {
  return new Promise((resolve, reject) => {
    db.collection('addressBook').doc(address.docId).delete().then(() => {
      resolve('Address deleted')
    }).catch(err => {
      // console.log(err)
      reject(err)
    })
  })
}